import en_US from './en-US';
import fr_CA from './fr-CA';

const locales = { "en-US": en_US, "fr-CA": fr_CA }

export default locales;
